import React from 'react';
import styles from './MissingAccount.module.scss';
export const MissingAccount = () => (<div className={styles.errorContainer}>
    <h2 className={styles.header}>Ooops, something went wrong!</h2>
    <p className='owners-body'>There&apos;s been an issue with your account.</p>
    <p className='owners-body'>
      Please call 0333 20 25 300 and ask to be re-registered for the Website.
    </p>
  </div>);
